export default __webpack_public_path__ + "73bdff8fd1c1b320b3c90b87ea8ee797.jpg";